import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Observações",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 6;
      }
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Observação Interna",
      "label-for": "observacaoInterna"
    }
  }, [_c(VTextarea, {
    attrs: {
      "full-width": "",
      "rows": "6"
    },
    model: {
      value: _vm.form.observacaoInterna,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacaoInterna", $$v);
      },
      expression: "form.observacaoInterna"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Observação",
      "label-for": "observacao"
    }
  }, [_c(VTextarea, {
    attrs: {
      "full-width": "",
      "rows": "6"
    },
    model: {
      value: _vm.form.observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacao", $$v);
      },
      expression: "form.observacao"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };